import { useContext } from 'react'
import { AwardsRouteContext } from './AwardsRouteContext'

export const useAwardsRouteContext = () => {
  const context = useContext(AwardsRouteContext)

  if (!context) {
    throw new Error('useAwardsRouteContext must be used within a useAwardsRouteContext.Provider')
  }

  return context
}
